import { gql } from '@apollo/client';

import { OutcomesFragment } from 'approot/shared/graphql/outcomes/outcomes.graphql';

export const assessmentTeachingLearningSequenceFragment = gql`
  fragment AssessmentTeachingLearningSequenceFragment on Assessment {
    id
    teachingAndLearningSequence {
      id
      category
      type
      data {
        span
        differentiation
        checkPoint
        duration
        richtext
        furtherEnrichment
      }
      questionGroupId
      sort
      theEsDetails {
        id
        name
        link
      }
      connections {
        subject
        outcomes {
          ...OutcomesFragment
          description
          type
        }
      }
    }
  }
  ${OutcomesFragment}
`;

export const UPDATE_ASSESSMENT_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation UpsertStaticTeachingLearningSequenceAssessmentItem(
    $input: UpsertStaticTeachingLearningSequenceItemInput!
  ) {
    upsertStaticTeachingLearningSequenceAssessmentItem(input: $input) {
      ...AssessmentTeachingLearningSequenceFragment
    }
  }
  ${assessmentTeachingLearningSequenceFragment}
`;

export const DELETE_ASSESSMENT_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation DeleteStaticTeachingLearningSequenceAssessmentItem(
    $input: DeleteStaticTeachingLearningSequenceItemInput!
  ) {
    deleteStaticTeachingLearningSequenceAssessmentItem(input: $input) {
      ...AssessmentTeachingLearningSequenceFragment
    }
  }
  ${assessmentTeachingLearningSequenceFragment}
`;
